import { HttpErrorResponse } from '@angular/common/http';

export const hasMessage = (error: unknown): error is Error =>
  (error as Error).message !== undefined;
export const isHttpErrorResponse = (error: unknown): error is HttpErrorResponse =>
  error instanceof HttpErrorResponse;
export const getHttpErrorResponse = (error: unknown): HttpErrorResponse =>
  isHttpErrorResponse(error)
    ? error
    : new HttpErrorResponse({ status: 500, statusText: 'internal error' });

export const isAtsForbidden = (status: number | undefined): boolean =>
  status === 403 || status === 404;
